// M8: Preflight and utilities precede every app stylesheet in both CRA modes.
import './styles/tailwind.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/step2d.css';
import './styles/step2k.css';
import './styles/modal3d.css';
import './styles/step2j.css';
import './styles/step2n.css';
import './styles/settingsNav.css';
import { supabaseClient } from './config/supabase';
import { doorBasePath, legacyBrandRedirectLocation } from './lib/signInDoors';
import { watchWebPushSignOut } from './lib/webPushSubscription';

watchWebPushSignOut(supabaseClient);

const legacyRedirect = legacyBrandRedirectLocation(window.location);
if (legacyRedirect) {
    const search = legacyRedirect.search;
    const hash = legacyRedirect.hash;
    window.history.replaceState(null, '', `${legacyRedirect.pathname}${search}${hash}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
// BL-177 Step 2d screenshot harness (dev server only, REACT_APP_STEP2D_PREVIEW=1, #/__step2d-preview/<screen>).
// The NODE_ENV check is a build-time constant, so a production build drops this branch and the harness chunk.
if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_STEP2D_PREVIEW === '1'
    && window.location.hash.startsWith('#/__step2d-preview')) {
    import('./dev/step2dPreview').then(({ default: Step2dPreview }) => root.render(<Step2dPreview />));
} else {
    root.render(
        <React.StrictMode>
            <BrowserRouter basename={doorBasePath(window.location)}>
                <App />
            </BrowserRouter>
        </React.StrictMode>
    );
}
